import GeolocationProvidersFactory from './GeolocationProvidersFactory';

/**
 * Represents GeolocationProvidersMgr
 */
class GeolocationProvidersMgr {
	/**
	 * Returns GeolocationProvider
	 * @param {String} providerId Provider Id
	 * @returns {GeolocationProvider}
	 */
	getProvider(providerId) {
		return GeolocationProvidersFactory.create(providerId);
	}
}

export default new GeolocationProvidersMgr();
